import { render, staticRenderFns } from "./SGPFormAutocompleteComponent.vue?vue&type=template&id=c8fc02e4"
import script from "./SGPFormAutocompleteComponent.vue?vue&type=script&lang=js"
export * from "./SGPFormAutocompleteComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPFormAutocompleteComponent.vue?vue&type=style&index=0&id=c8fc02e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports